module.exports = __webpack_public_path__ + "assets/icon_jd_power_green.23c11df3.svg";